<template>
  <tm-gradient-badge-small
    :text="text"
    :theme="theme"
  />
</template>

<script setup lang="ts">
import { computed } from '@/composition/vue/compositionApi'
import TmGradientBadgeSmall from '@/components/shared/badge/TmGradientBadgeSmall.vue'
import type { TmMenuItemBadge } from '@/components/shared/types'
import type { TmGradientBadgeTheme } from '@/components/shared/badge/types'
import { useSidebarState } from '@/composition/layout/pageContent/sidebar'
import { getTranslateService } from '@/core/container/ioc'

const { badge } = defineProps<{
  badge: TmMenuItemBadge
}>()

const translateService = getTranslateService()
const { sidebarWidth } = useSidebarState(undefined, 'settingsSidebarWidth')

const badgeColorMap: Record<TmMenuItemBadge, TmGradientBadgeTheme> = {
  new: 'purple',
  beta: 'purple',
  tryNow: 'green',
}

const theme = computed(() => {
  return badgeColorMap[badge] ?? 'purple'
})

const text = computed(() => {
  if (sidebarWidth.value <= 240) return undefined
  return translateService.t(`badges.${badge}`)
})
</script>
